const supportedBindings = ['<', '@', '=', '&', '#'];

export default function getComponentDefinition(ReactComponent, bindings = [], dependencies = []) {
  const parseBindings = (bindingsArray) => {
    const componentBindings = {};

    bindingsArray.forEach((binding) => {
      let bindingType = binding.charAt(0);
      let bindingName = binding.substr(1);

      if (!supportedBindings.includes(bindingType)) {
        bindingType = '<';
        bindingName = binding;
      }

      componentBindings[bindingName] = bindingType;
    });

    return componentBindings;
  };

  return {
    ReactComponent,
    bindings: parseBindings(bindings),
    dependencies,
  };
}
